export type Uuid = string;

export const HIDDEN_SPACE = '‎ ';

export function uuid(): Uuid {
  return crypto.randomUUID();
}

export const isProduction = process.env.NODE_ENV === 'production';
